import { Module } from '../Module';
import { GetTagsRequest, IGetTagsResult } from '../ServerApi/requests/GetTagsRequest';
import { ITag } from '../ServerApi/types/ITag';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class Tags extends Resource<ITag> {

  public static $inject = ['FetcherFactory'];

  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetTagsRequest,
      (result: IGetTagsResult) => result.tags));
  }

}

Module.instance().service('Tags', Tags);
